import React from "react";
import Preferences from "./Preferences";
import manPraying from "../assets/images/man_praying.svg";

const Header = () => {
  return (
    <div >
      <Preferences />
      <img src={manPraying} alt="Man praying" />
    </div>
  );
};

export default Header;
